import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "overlay", "blockLabel", "list", "emptyState", "userSelect", "workBlockId", "workCategoryId", "submitButton"]
  static values = { authToken: String, removeLabel: String }

  open(event) {
    event.preventDefault()

    const { label, blockedEntries, availableUsers, workBlockId, workCategoryId, emptyLabel, emptyUsersLabel, selectPrompt } = event.currentTarget.dataset
    const entries = JSON.parse(blockedEntries || "[]")
    const users = JSON.parse(availableUsers || "[]")

    this.blockLabelTarget.textContent = label
    this.workBlockIdTarget.value = workBlockId || ""
    this.workCategoryIdTarget.value = workCategoryId || ""
    this.listTarget.innerHTML = ""
    this.userSelectTarget.innerHTML = ""

    if (entries.length > 0) {
      entries.forEach((entry) => {
        const item = document.createElement("li")
        item.className = "flex items-center justify-between rounded-lg bg-white px-3 py-2 text-sm text-gray-900 shadow-sm"
        item.innerHTML = `<span>${entry.name}</span>`

        const form = document.createElement("form")
        form.method = "post"
        form.action = `/work_block_blocked/${entry.id}`
        form.innerHTML = `
          <input type="hidden" name="_method" value="delete">
          <input type="hidden" name="authenticity_token" value="${this.authTokenValue}">
          <input type="hidden" name="work_category_id" value="${this.workCategoryIdTarget.value}">
          <button type="submit" class="rounded-md p-1 text-gray-400 transition-colors hover:bg-red-50 hover:text-red-500" aria-label="${this.removeLabelValue}" title="${this.removeLabelValue}">×</button>
        `
        item.appendChild(form)
        this.listTarget.appendChild(item)
      })
      this.listTarget.classList.remove("hidden")
      this.emptyStateTarget.classList.add("hidden")
    } else {
      this.listTarget.classList.add("hidden")
      this.emptyStateTarget.textContent = emptyLabel || ""
      this.emptyStateTarget.classList.remove("hidden")
    }

    const prompt = document.createElement("option")
    prompt.value = ""
    prompt.textContent = users.length > 0 ? (selectPrompt || "") : (emptyUsersLabel || "")
    this.userSelectTarget.appendChild(prompt)

    users.forEach((user) => {
      const option = document.createElement("option")
      option.value = user.id
      option.textContent = user.name
      this.userSelectTarget.appendChild(option)
    })

    this.userSelectTarget.disabled = users.length === 0
    this.submitButtonTarget.disabled = true
    this.modalTarget.classList.remove("hidden")
    document.body.style.overflow = "hidden"
  }

  userChanged() {
    this.submitButtonTarget.disabled = !this.userSelectTarget.value
  }

  close() {
    this.modalTarget.classList.add("hidden")
    document.body.style.overflow = ""
  }

  closeOnOverlay(event) {
    if (event.target === this.overlayTarget) {
      this.close()
    }
  }

  closeOnEscape(event) {
    if (event.key === "Escape") {
      this.close()
    }
  }
}
